var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-badge"},[(_vm.audit)?_c('b-badge',{staticClass:"badge-link",attrs:{"variant":_vm.variant},on:{"click":_vm.editAudit}},[_c('a',[_vm._v(_vm._s(_vm.status))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }